import React from 'react';
import { Text, RadioGroup, Radio } from 'rsuite';
import {
  LOCAL_CONTACT,
  PROPERTY_MANAGEMENT_OPTIONS,
} from '../../payment/constants';
import { ValueType } from 'rsuite/esm/Radio';
import FormFieldErrorIcon from '../FormFieldErrorIcon';

interface LocalContactRadioGroupProps {
  error?: string;
  isTenant?: boolean;
  isOwner?: boolean;
  isPropertyManager?: boolean;
  localContactVerbiage: string;
  onChange: (value: LOCAL_CONTACT) => void;
  propertyManager: PROPERTY_MANAGEMENT_OPTIONS;
  selectedError?: string;
  value: LOCAL_CONTACT;
}
const PM_LABEL = 'The Property Manager';
const OWNER_LABEL = 'The Owner';
const MYSELF_PM_LABEL = 'Myself (the Property Manager)';
const MYSELF_OWNER_LABEL = 'Myself (the Owner)';
const MYSELF_TENANT_LABEL = 'Myself (the Tenant)';
const MYSELF_LABEL = 'Myself';
const SOMEONE_ELSE_LABEL = 'Someone else';

export const LocalContactRadioGroup = ({
  error,
  isOwner,
  isTenant,
  isPropertyManager,
  localContactVerbiage,
  onChange,
  propertyManager,
  selectedError,
  value,
}: LocalContactRadioGroupProps) => {
  const handleChange = (value: ValueType) => {
    onChange(value as LOCAL_CONTACT);
  };

  const errorId = 'local-contact-group-error';

  const errorMessage = selectedError && (
    <div
      id={errorId}
      className="text-error"
      style={{ marginTop: '4px' }}
    >
      {selectedError}
    </div>
  );

  return (
    <fieldset style={{ border: 'none', margin: 0, padding: 0 }}>
      <legend>
        <Text>
          Who is the {localContactVerbiage.toLowerCase()} for this property?
        </Text>
      </legend>
      <RadioGroup
        name="owner-rep-radio-option-group"
        defaultValue={LOCAL_CONTACT.OWNER}
        value={value}
        onChange={handleChange}
        aria-invalid={selectedError ? true : undefined}
        aria-describedby={selectedError ? errorId : undefined}
      >
        {isOwner && (
          <Radio value={LOCAL_CONTACT.OWNER}>
            <span
              className={
                value === LOCAL_CONTACT.OWNER && selectedError
                  ? 'text-error'
                  : undefined
              }
            >
              {!isOwner ? MYSELF_LABEL : MYSELF_OWNER_LABEL}
            </span>
          </Radio>
        )}
        {isOwner && value === LOCAL_CONTACT.OWNER && errorMessage}
        {isPropertyManager && !isOwner && (
          <Radio value={LOCAL_CONTACT.PROPERTY_MANAGER}>
            <span
              className={
                value === LOCAL_CONTACT.PROPERTY_MANAGER && selectedError
                  ? 'text-error'
                  : undefined
              }
            >
              {MYSELF_PM_LABEL}
            </span>
          </Radio>
        )}
        {isPropertyManager &&
          !isOwner &&
          value === LOCAL_CONTACT.PROPERTY_MANAGER &&
          errorMessage}
        {!isOwner && (
          <Radio value={LOCAL_CONTACT.OWNER}>
            <span
              className={
                value === LOCAL_CONTACT.OWNER && selectedError
                  ? 'text-error'
                  : undefined
              }
            >
              {OWNER_LABEL}
            </span>
          </Radio>
        )}
        {!isOwner && value === LOCAL_CONTACT.OWNER && errorMessage}
        {((!isPropertyManager &&
          propertyManager !== PROPERTY_MANAGEMENT_OPTIONS.SELF_MANAGED) ||
          (isPropertyManager &&
            isOwner &&
            propertyManager ===
              PROPERTY_MANAGEMENT_OPTIONS.PROPERTY_MANAGER)) && (
          <Radio value={LOCAL_CONTACT.PROPERTY_MANAGER}>
            <span
              className={
                value === LOCAL_CONTACT.PROPERTY_MANAGER && selectedError
                  ? 'text-error'
                  : undefined
              }
            >
              {PM_LABEL}
            </span>
          </Radio>
        )}
        {((!isPropertyManager &&
          propertyManager !== PROPERTY_MANAGEMENT_OPTIONS.SELF_MANAGED) ||
          (isPropertyManager &&
            isOwner &&
            propertyManager ===
              PROPERTY_MANAGEMENT_OPTIONS.PROPERTY_MANAGER)) &&
          value === LOCAL_CONTACT.PROPERTY_MANAGER &&
          errorMessage}
        {isTenant && !isOwner && !isPropertyManager && (
          <Radio value={LOCAL_CONTACT.TENANT}>
            <span
              className={
                value === LOCAL_CONTACT.TENANT && selectedError
                  ? 'text-error'
                  : undefined
              }
            >
              {MYSELF_TENANT_LABEL}
            </span>
          </Radio>
        )}
        {isTenant &&
          !isOwner &&
          !isPropertyManager &&
          value === LOCAL_CONTACT.TENANT &&
          errorMessage}
        <Radio value={LOCAL_CONTACT.OTHER}>
          <span
            className={
              value === LOCAL_CONTACT.OTHER && selectedError
                ? 'text-error'
                : undefined
            }
          >
            {SOMEONE_ELSE_LABEL}
          </span>
        </Radio>
        {value === LOCAL_CONTACT.OTHER && errorMessage}
      </RadioGroup>
      {error && <FormFieldErrorIcon errorMessage={error} />}
    </fieldset>
  );
};
